import { styled } from "@mui/material/styles";
import { ReactNode } from "react";

import { useNextTranslation } from "../hooks";
import { Link } from "../navigation";
import { Flex } from "./Flex";
import { Typography } from "./Typography";

type PoweredByProps = {
    children?: ReactNode;
};
export const PoweredBy = ({ children }: PoweredByProps) => {
    const [tGeneral] = useNextTranslation("general");
    const [tHbml] = useNextTranslation("hbml");
    return (
        <Flex column gap={6}>
            <Text size="small">{tHbml("poweredBy.label")}</Text>
            <LinkStyled href={"https://holibob.tech"} newTab={true}>
                <TypographyStyled variant="h2" component="h2" href="https://holibob.tech">
                    holibob
                </TypographyStyled>
            </LinkStyled>
            <LinkStyled href={"/holibob-privacy-policy"} newTab={true}>
                <Text size="small">{tGeneral("privacyPolicy")}</Text>
            </LinkStyled>
            {children}
        </Flex>
    );
};

const TypographyStyled = styled(Typography)({
    fontFamily: "Gill Sans, Montserrat",
    color: "inherit",
});

const Text = styled(Typography)({
    color: "inherit",
});

const LinkStyled = styled(Link)({
    color: "inherit",
});
